import "@coreui/coreui/dist/css/coreui.min.css";
import {
  CButton,
  CCard,
  CCardBody,
  CCardFooter,
  CCardHeader,
  CCol,
  CRow,
  CBadge,
} from "@coreui/react";
import DoubleArrowIcon from "@mui/icons-material/DoubleArrow";
import PreviewIcon from "@mui/icons-material/Preview";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ReplayIcon from "@mui/icons-material/Replay";
import React, { useState, useEffect, useRef, useCallback } from "react";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import postApiCall from "src/server/postApiCall";
import { Toast } from "primereact/toast";
import "../../../src/css/quillp.scss";
import "./Quiz.css";
import FillInTheBlanks from "./QuizComponents/FillInTheBlanks";
import MultipleChoice from "./QuizComponents/MultipleChoice";
import MultipleSelect from "./QuizComponents/MultipleSelect";
import NumericResponse from "./QuizComponents/NumericResponse";
import TrueFalse from "./QuizComponents/TrueFalse";
import TextAnswer from "./QuizComponents/TextAnswer";
import YesNo from "./QuizComponents/YesNo";
import ReviewQuiz from "./QuizComponents/ReviewQuiz";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import FeedBackPop from "../FeedBackPop/FeedBackPop";

function Quizstudentlist({ detail, sectionType }) {
  const courseDetails = detail,
    questionArray = detail?.questions,
    [questionAnswerData, setQuestionAnswerData] = useState([]),
    [evaluationAnswer, setEvaluationAnswer] = useState([]),
    trainingId1 = window.location.href.split("?")[1],
    assessmentId = window.location.href.split("?")[3];
  const blendedId = window.location.href.split("?")[4],
    learningplanId = window.location.href.split("?")[5],
    assignmentId = window.location.href.split("?")[6],
    [revealScore, setRevealScore] = useState(false),
    [questionIdCount, setQuestionIdCount] = useState([]),
    colorName = localStorage.getItem("ThemeColor"),
    [themes] = useState(colorName),
    navigate = useNavigate(),
    toast = useRef(null),
    [comments, setComments] = useState(""),
    [currentQuestion, setCurrentQuestion] = useState(0),
    [currentIndex, setCurrentIndex] = useState(-1),
    [loading, setLoading] = useState(false),
    [showReviewList, setShowReviewlist] = useState(false),
    [valueReset, setValueReset] = useState(false),
    [quizdetails, setQuizDetails] = useState(),
    [attemptExceeded, setAttemptExceeded] = useState(0),
    [rateCourseVisible, setRateCourseVisible] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const cardBodyRef = useRef(null);
  const [showScrollIndicator, setShowScrollIndicator] = useState(false);
  const [hasReturnedFromReview, setHasReturnedFromReview] = useState(false);

  useEffect(() => {
    const checkScroll = () => {
      const element = cardBodyRef.current;
      if (element) {
        const hasScroll = element.scrollHeight > element.clientHeight;
        const isAtBottom =
          Math.abs(
            element.scrollHeight - element.scrollTop - element.clientHeight
          ) < 1;
        setShowScrollIndicator(hasScroll && !isAtBottom);
      }
    };

    const element = cardBodyRef.current;
    if (element) {
      checkScroll();
      element.addEventListener("scroll", checkScroll);
      window.addEventListener("resize", checkScroll);

      return () => {
        element.removeEventListener("scroll", checkScroll);
        window.removeEventListener("resize", checkScroll);
      };
    }
  }, [questionAnswerData]);

  const scrollToBottom = () => {
    if (cardBodyRef.current) {
      cardBodyRef.current.scrollTo({
        top: cardBodyRef.current.scrollHeight,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    if (courseDetails) {
      if (courseDetails?.displayType === 0) {
        setCurrentIndex(0);
        setQuestionAnswerData([courseDetails?.questions[0]]);
      } else {
        setQuestionAnswerData(courseDetails?.questions);
      }
    }
  }, [courseDetails]);


  useEffect(() => {
    if (currentIndex !== -1) {
      setQuestionAnswerData([questionArray[currentIndex]]);
      setCurrentQuestion(currentIndex);
      setValueReset(!valueReset);
    }
  }, [currentIndex]);

  const handleAnswerChange = useCallback(
    (questionId, questionTypeID, value) => {
      setEvaluationAnswer((prev) => {
        const filterValue = prev.filter(
          (item) => item.questionId !== questionId
        );
        return [
          ...filterValue,
          {
            questionId: questionId,
            questionTypeId: questionTypeID,
            answerValue: value,
          },
        ];
      });
      setQuestionIdCount((pre) => {
        if (!pre.includes(questionId)) {
          return [...pre, questionId];
        }
        return pre;
      });
    },
    []
  );


  const finalSubmit = async () => {
    const payload = {
      studentAnswers: evaluationAnswer,
      markCompleted: 1,
      courseId: trainingId1,
      assessmentId: parseInt(assessmentId),
      blendedProgramId: blendedId || "",
      learningplanId: learningplanId || "",
      assignmentId: assignmentId || "",
    };

    setLoading(true);
    try {
      const res = await postApiCall("addAssessmentUserAnswers", payload);
      const resultData = res?.data ?? res;

      if (resultData) {
        const { attemptRemaining, score, result } = resultData;
        setQuizDetails({ attemptRemaining, score, result });
        setAttemptExceeded(attemptRemaining);
      }
      return resultData;
    } catch (err) {
      console.error("Submit failed", err);
    } finally {
      setLoading(false);
    }
  };

const handleSubmit = async () => {
  const res = await finalSubmit();
  setRevealScore(true);
  setLoading(false);

  if (detail?.quizType !== "Quiz") {
    await setCompleteCourseApi("Pass");
    setRateCourseVisible(true);
  } else if (res?.result) {
    await setCompleteCourseApi(res.result);
  }
};

  const handleCloseWindow = () => {
    navigate(-1);
  };

  const setCompleteCourseApi = async (result) => {
    const payLoad = {
      courseId: parseInt(trainingId1),
      resultStatus: result,
      blendedProgramId: blendedId || "",
      learningplanId: learningplanId || "",
      assignmentId: assignmentId || "",
    };
    try {
      await postApiCall("studentCompletedCourse", payLoad);
    } catch (error) { }
  };

  const addUserFeedbackApi = async () => {
    const payLoad = {
      trainingId: parseInt(trainingId1),
      feedback: comments,
      blendedProgramId: blendedId || "",
      learningplanId: learningplanId || "",
      assignmentId: assignmentId || "",
    };
    try {
      const response = await postApiCall("addUserRating", payLoad);
      if (response) {
        toast?.current?.show({
          severity: "success",
          summary: "Success",
          detail: "Feedback Sent Successfully",
          life: 3000,
        });
        setRateCourseVisible(false);
      }
    } catch (error) { }
  };

  const rateCourseDialogFooter = () => (
    <div className="d-flex justify-content-end w-100">
      <button
        icon="pi pi-check"
        className={`btn btn-primary`}
        onClick={async () => {
          await addUserFeedbackApi();
          setTimeout(() => {
            handleCloseWindow();
          }, 1000);
        }}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "8px",
          fontSize: isMobile || isTablet ? "14px" : "16px",
          padding: isMobile || isTablet ? "8px 16px" : "10px 20px",
          width: isMobile || isTablet ? "140px" : "160px",
          height: isMobile || isTablet ? "44px" : "48px",
          backgroundColor: "#0d6efd",
          color: "#ffffff",
          border: "none",
          borderRadius: "4px"
        }}
      >
        Submit <DoubleArrowIcon />
      </button>
    </div>
  );

  const handlePrevClick = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  const handleNextClick = () => {
    if (currentIndex < questionArray.length) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const handleRetakeCourse = () => {
    setRevealScore(false);
    setQuestionAnswerData(
      courseDetails?.displayType === 0
        ? [courseDetails?.questions[0]]
        : courseDetails?.questions
    );
    setShowReviewlist(false);
    setHasReturnedFromReview(false);
    setComments("");
  };

const handleFinishClick = async () => {
  setRateCourseVisible(true);
};

  return (
    <>
      <Toast ref={toast} />
      {showReviewList ? (
        <div
          className={`w-0 h-0`}
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            margin: detail.displayType === 0 ? "100px" : "0px",
          }}
        >
          <CCard style={{ margin: "0 4.5rem", minHeight: "60%", width: "80%" }}>
            <CCardHeader className={`formHeader${themes}`}>
              <div className="flex">
                <div>
                  <strong style={{ fontWeight: "600", fontSize: "30px" }}>
                    {courseDetails.courseName} Summary
                  </strong>
                </div>

                <div className="flex">
                  {detail?.creditsVisible === 1 &&
                    detail?.credits != null &&
                    detail?.quizType === "Quiz" && (
                      <strong className="h6" style={{ fontWeight: "800" }}>
                        Credit :{" "}
                        {String(detail?.credits)
                          .split("")
                          .reduce((count, digit) => count + 1, 0) > 1
                          ? ""
                          : "0"}
                        {detail?.credits}
                      </strong>
                    )}
                  {detail?.timerOn === 1 && detail?.quizType === "Quiz" && (
                    <strong className="h6" style={{ fontWeight: "800" }}>
                      {" "}
                      | Total Time :
                      {`${parseInt(detail?.hours) > 0
                        ? ` ${detail?.hours} hour`
                        : ""
                        } `}
                      {`${parseInt(detail?.minutes) > 0
                        ? `${detail?.minutes} minutes`
                        : ""
                        } `}
                    </strong>
                  )}
                </div>
              </div>
            </CCardHeader>
            <CCardBody>
              <ReviewQuiz
                trainingId={trainingId1}
                blendedId={blendedId}
                learningPlanId={learningplanId}
                assignmentId={assignmentId}
              />
            </CCardBody>
            <CCardFooter style={{ backgroundColor: "#f0f0f0" }} className="fixed-footer">
              <CRow className="justify-content-between">
                <CCol xs="auto">
                  <CButton
                    className={`saveButtonTheme${themes}`}
                    onClick={() => {
                      setShowReviewlist(false);
                      setHasReturnedFromReview(true);
                    }}
                  >
                    <ArrowBackIcon /> Back
                  </CButton>
                </CCol>
              </CRow>
            </CCardFooter>
          </CCard>
        </div>
      ) : (
        <div>
          <CCard style={{ width: "100%", height: "100vh" }}>
            <CCardHeader className={`formHeader${themes}`}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <strong style={{ fontWeight: "600", fontSize: "30px" }}>
                  {detail?.courseName}
                </strong>
                <Button
                  variant="contained"
                  onClick={handleCloseWindow}
                  sx={{
                    bgcolor: "error.main",
                    "&:hover": { bgcolor: "error.dark" },
                    textTransform: "none",
                  }}
                >
                  Close
                </Button>
              </div>
              <div>
                <div className="flex">
                  {detail?.creditsVisible === 1 &&
                    detail?.credits != null &&
                    detail?.quizType === "Quiz" && (
                      <strong className="h6" style={{ fontWeight: "800" }}>
                        Credit :{" "}
                        {String(detail?.credits)
                          .split("")
                          .reduce((count, digit) => count + 1, 0) > 1
                          ? ""
                          : "0"}
                        {detail?.credits}
                      </strong>
                    )}
                  {detail?.timerOn === 1 && detail?.quizType === "Quiz" && (
                    <strong className="h6" style={{ fontWeight: "800" }}>
                      {" "}
                      | Total Time :
                      {`${parseInt(detail?.hours) > 0
                        ? ` ${detail?.hours} hour`
                        : ""
                        } `}
                      {`${parseInt(detail?.minutes) > 0
                        ? `${detail?.minutes} minutes`
                        : ""
                        } `}
                    </strong>
                  )}
                </div>
              </div>
            </CCardHeader>

            {!revealScore ? (
              <>
                <CCardBody
                  ref={cardBodyRef}
                  style={{
                    height: "75vh",
                    overflowY: "auto",
                    position: "relative",
                  }}
                >
                  <CRow
                    style={{
                      height: isMobile || isTablet ? "auto" : "80%",
                      width: isMobile || isTablet ? "100%" : "70%"
                    }}
                    className="questionAnswerHeight"
                  >
                    {questionAnswerData &&
                      questionAnswerData?.map((item, index) => {
                        switch (item?.questionTypeId) {
                          case 1:
                            return (
                              <MultipleChoice
                                type={sectionType}
                                key={index}
                                num={
                                  courseDetails?.displayType === 0
                                    ? currentQuestion
                                    : index
                                }
                                question={item.question}
                                data={item.options}
                                onAnswerChange={handleAnswerChange}
                                questionID={item.questionId}
                                questionTypeID={item.questionTypeId}
                                assessmentID={item.assessmentSettingId}
                                trainingId1={trainingId1}
                                assessmentId={assessmentId}
                                questionIdCount={questionIdCount}
                              />
                            );
                          case 2:
                            return (
                              <MultipleSelect
                                type={sectionType}
                                key={index}
                                num={
                                  courseDetails?.displayType === 0
                                    ? currentQuestion
                                    : index
                                }
                                question={item.question}
                                data={item.options}
                                onAnswerChange={handleAnswerChange}
                                questionTypeID={item.questionTypeId}
                                assessmentID={item.assessmentSettingId}
                                questionID={item.questionId}
                              />
                            );
                          case 3:
                            return (
                              <TrueFalse
                                type={sectionType}
                                key={index}
                                num={
                                  courseDetails?.displayType === 0
                                    ? currentQuestion
                                    : index
                                }
                                question={item.question}
                                data={item.options}
                                onAnswerChange={handleAnswerChange}
                                questionID={item.questionId}
                                assessmentID={item.assessmentSettingId}
                                questionTypeID={item.questionTypeId}
                              />
                            );
                          case 4:
                            return (
                              <YesNo
                                type={sectionType}
                                key={index}
                                num={
                                  courseDetails?.displayType === 0
                                    ? currentQuestion
                                    : index
                                }
                                question={item.question}
                                data={item.options} // Updated from item.answer to item.options
                                onAnswerChange={handleAnswerChange}
                                questionID={item.questionId}
                                assessmentID={item.assessmentSettingId}
                                questionTypeID={item.questionTypeId}
                              />
                            );
                          case 5: // Text Answer case
                            return (
                              <TextAnswer
                                type={sectionType}
                                key={index}
                                num={
                                  courseDetails?.displayType === 0
                                    ? currentQuestion
                                    : index
                                }
                                question={item.question}
                                onAnswerChange={handleAnswerChange}
                                questionID={item.questionId}
                                questionTypeID={item.questionTypeId}
                                trainingId1={trainingId1}
                                assessmentId={assessmentId}
                                questionIdCount={questionIdCount}
                                isCorrect={item.isCorrect}
                              />
                            );
                          case 6:
                            return (
                              <NumericResponse
                                type={sectionType}
                                key={index}
                                num={
                                  courseDetails?.displayType === 0
                                    ? currentQuestion
                                    : index
                                }
                                question={item.question}
                                data={item.options}
                                questionID={item.questionId}
                                onAnswerChange={handleAnswerChange}
                                assessmentID={item.assessmentSettingId}
                                questionTypeID={item.questionTypeId}
                                valueReset={valueReset}
                              />
                            );
                          case 7:
                            return (
                              <FillInTheBlanks
                                type={sectionType}
                                key={index}
                                num={
                                  courseDetails?.displayType === 0
                                    ? currentQuestion
                                    : index
                                }
                                question={item.question}
                                onAnswerChange={handleAnswerChange}
                                data={item.options}
                                questionID={item.questionId}
                                assessmentID={item.assessmentSettingId}
                                questionTypeID={item.questionTypeId}
                                valueReset={valueReset}
                              />
                            );
                          default:
                            return <p key={index}>No Quiz</p>;
                        }
                      })}
                  </CRow>
                  {showScrollIndicator && (
                    <div className="scroll-indicator" onClick={scrollToBottom}>
                      <KeyboardArrowDownIcon />
                    </div>
                  )}
                </CCardBody>

                <CCardFooter>
                  <CRow className="justify-content-center">
                    {detail.displayType === 1 && sectionType === "3" && (
                      <CCol xs="auto">
                        <CButton
                          className={`saveButtonTheme${themes}`}
                          onClick={handleSubmit}
                        >
                          <DoubleArrowIcon /> Finish
                        </CButton>
                      </CCol>
                    )}

                    {detail.displayType === 0 && (
                      <CCol xs="auto">
                        <div
                          style={{
                            gap: "1rem",
                            alignItems: "center",
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          <CButton
                            disabled={currentIndex == 0 ? true : false}
                            className={`saveButtonTheme${themes}`}
                            onClick={handlePrevClick}
                          >
                            <ArrowBackIcon /> Previous
                          </CButton>

                          {detail && detail.questions && (
                            <div
                              style={{
                                fontSize: "1.1rem",
                                padding: "0.2rem",
                              }}
                            >
                              {currentIndex + 1} / {detail?.questions?.length}
                            </div>
                          )}

                          {currentIndex + 1 !== detail?.questions?.length && (
                            <CButton onClick={handleNextClick}>Next</CButton>
                          )}
                          {sectionType === "3" &&
                            (currentIndex + 1 === detail?.questions?.length ||
                              currentIndex === -1) && (
                              <CButton
                                className={`saveButtonTheme${themes}`}
                                // size="md"
                                onClick={handleSubmit}
                              >
                                <DoubleArrowIcon /> Submit
                              </CButton>
                            )}
                        </div>
                      </CCol>
                    )}

                    {/* <CCol xs="auto">
                      <CButton
                        color="dark"
                        size="md"
                        onClick={() => {
                          navigate(-1);
                        }}
                      >
                        Back
                      </CButton>
                    </CCol> */}
                  </CRow>
                </CCardFooter>
              </>
            ) : (
              <CCardBody
                style={{
                  height: "90%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {loading ? (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "100%",
                    }}
                  >
                    <span
                      className="spinner-border spinner-border-lg"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  </div>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "100%",
                      maxWidth: "800px",
                      padding: "2rem",
                    }}
                  >
                    {detail?.quizType === "Quiz" ? (
                      <>
                        {/* Completion Message */}
                        <div
                          style={{ textAlign: "center", marginBottom: "2rem" }}
                        >
                          <CBadge
                            color={
                              quizdetails?.result === "Pass"
                                ? "success"
                                : quizdetails?.result === "Fail"
                                  ? "danger"
                                  : "secondary"
                            }
                            style={{
                              fontSize: "1.5rem",
                              padding: "1rem 2rem",
                              borderRadius: "8px",
                            }}
                          >
                            {quizdetails?.result === "Pass" ? (
                              <span>✓ Assessment Completed Successfully!</span>
                            ) : (
                              <span>Assessment Failed</span>
                            )}
                          </CBadge>
                          <h3 style={{ marginTop: "1rem", fontWeight: 600 }}>
                            {detail?.courseName}
                          </h3>
                        </div>

                        {/* Results Card */}
                        <CCard
                          style={{
                            width: "100%",
                            marginBottom: "2rem",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                          }}
                        >
                          <CCardBody>
                            <CRow className="text-center">
                              <CCol md={3} className="mb-3">
                                <div>
                                  <strong
                                    style={{
                                      display: "block",
                                      fontSize: "0.9rem",
                                      color: "#6c757d",
                                      marginBottom: "0.5rem",
                                    }}
                                  >
                                    Total Questions
                                  </strong>
                                  <div
                                    style={{
                                      fontSize: "2rem",
                                      fontWeight: "bold",
                                      color: "#495057",
                                    }}
                                  >
                                    {courseDetails?.questions?.length || 0}
                                  </div>
                                </div>
                              </CCol>
                              <CCol md={3} className="mb-3">
                                <div>
                                  <strong
                                    style={{
                                      display: "block",
                                      fontSize: "0.9rem",
                                      color: "#6c757d",
                                      marginBottom: "0.5rem",
                                    }}
                                  >
                                    Score
                                  </strong>
                                  <div
                                    style={{
                                      fontSize: "2rem",
                                      fontWeight: "bold",
                                      color: "#495057",
                                    }}
                                  >
                                    {quizdetails?.score || 0}
                                  </div>
                                </div>
                              </CCol>
                              <CCol md={3} className="mb-3">
                                <div>
                                  <strong
                                    style={{
                                      display: "block",
                                      fontSize: "0.9rem",
                                      color: "#6c757d",
                                      marginBottom: "0.5rem",
                                    }}
                                  >
                                    Result
                                  </strong>
                                  <div
                                    style={{
                                      fontSize: "2rem",
                                      fontWeight: "bold",
                                      color:
                                        quizdetails?.result === "Pass"
                                          ? "#28a745"
                                          : quizdetails?.result === "Fail"
                                            ? "#dc3545"
                                            : "#495057",
                                    }}
                                  >
                                    {quizdetails?.result || "N/A"}
                                  </div>
                                </div>
                              </CCol>
                            </CRow>
                          </CCardBody>
                        </CCard>

                        {/* Action Buttons */}
                        <div
                          style={{
                            display: "flex",
                            gap: "1rem",
                            flexWrap: "wrap",
                            justifyContent: "center",
                            width: "100%",
                          }}
                        >
                          {/* If failed and returned from review: only show Retake */}
                          {quizdetails?.result === "Fail" &&
                            hasReturnedFromReview ? (
                            attemptExceeded !== 0 && (
                              <CButton
                                className={`saveButtonTheme${themes}`}
                                onClick={() => handleRetakeCourse()}
                                style={{ minWidth: "150px" }}
                              >
                                <ReplayIcon /> Retake
                              </CButton>
                            )
                          ) : quizdetails?.result === "Fail" ? (
                            <>
                              {/* If failed (first time): show Retake and Review */}
                              {attemptExceeded !== 0 && (
                                <CButton
                                  className={`saveButtonTheme${themes}`}
                                  onClick={() => handleRetakeCourse()}
                                  style={{ minWidth: "150px" }}
                                >
                                  <ReplayIcon /> Retake
                                </CButton>
                              )}
                              <CButton
                                className={`saveButtonTheme${themes}`}
                                onClick={() => {
                                  setShowReviewlist(true);
                                }}
                                style={{ minWidth: "150px" }}
                              >
                                <PreviewIcon /> Review
                              </CButton>
                            </>
                          ) : quizdetails?.result === "Pass" &&
                            hasReturnedFromReview ? (
                            <>
                              {/* If passed and returned from review: only show Finish */}
                              <CButton
                                className={`saveButtonTheme${themes}`}
                                onClick={handleFinishClick}
                                style={{ minWidth: "150px" }}
                              >
                                <DoubleArrowIcon /> Finish
                              </CButton>
                            </>
                          ) : (
                            <>
                              {/* If passed (first time): show Review, Retake, and Finish */}
                              <CButton
                                className={`saveButtonTheme${themes}`}
                                onClick={() => {
                                  setShowReviewlist(true);
                                }}
                                style={{ minWidth: "150px" }}
                              >
                                <PreviewIcon /> Review
                              </CButton>
                              {attemptExceeded !== 0 && (
                                <CButton
                                  className={`saveButtonTheme${themes}`}
                                  onClick={() => handleRetakeCourse()}
                                  style={{ minWidth: "150px" }}
                                >
                                  <ReplayIcon /> Retake
                                </CButton>
                              )}
                              <CButton
                                className={`saveButtonTheme${themes}`}
                                onClick={handleFinishClick}
                                style={{ minWidth: "150px" }}
                              >
                                <DoubleArrowIcon /> Finish
                              </CButton>
                            </>
                          )}
                        </div>
                      </>
                    ) : null}
                  </div>
                )}
              </CCardBody>
            )}
          </CCard>
        </div>
      )}
        <FeedBackPop
        visible={rateCourseVisible}
        onHide={() => {
          setRateCourseVisible(false);
        }}
        themes={themes}
        courseId={parseInt(trainingId1)}
        blendedIdcode={blendedId || ""}
        learningPlanIdcode={learningplanId || ""}
        assignmentIdcode={assignmentId || ""}
        grpTrainingId={0}
        onSubmit={() => {
          setRateCourseVisible(false);
          handleCloseWindow();
        }}
      />
    </>
  );
}

export default Quizstudentlist;
